import { Component } from '@angular/core';
import { AppLoadService } from './app-load-service';

@Component({
    selector: 'ebb-v2-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class LicensedDesignProfessionalSearchAppComponent {
  title = 'ebb-licensed-design-professional-app-search';

  public openOption = 'default';

  constructor(
    private readonly apiAppSettings: AppLoadService
  ) {
   }
}
